const ShimmerLoader = ({ className }) => {
  return (
    <div className={className}>
      <div
        className={`relative overflow-hidden w-full h-full bg-gray-200`}
      >
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-gray-200 via-white to-gray-200" />
      </div>
    </div>
  );
};

export default ShimmerLoader;